const items = [
    {
        title: 'Lorem ipsum 1',
    },
    {
        title: 'Lorem ipsum 2',
    },
    {
        title: 'Lorem ipsum 3',
    },
    {
        title: 'Lorem ipsum 4',
    },
    {
        title: 'Lorem ipsum 5',
    },
    {
        title: 'Lorem ipsum 6',
    },
    {
        title: 'Lorem ipsum 7',
    },
    {
        title: 'Lorem ipsum 8',
    },
    {
        title: 'Lorem ipsum 9',
    },
    {
        title: 'Lorem ipsum 9',
    },
]

export default items


/** WEBPACK FOOTER **
 ** ./src/items.js
 **/